// Import from the new plugin structure
import {
  ExamplePlugin,
  getAllExamplePlugins,
  getExamplePluginsByCategory as getExamplesByCategory,
  getExamplePluginsByDifficulty as getExamplesByDifficulty,
  searchExamplePlugins as searchExamples,
} from "@fuse/plugins/examples"
import { getAllZeroConfigPlugins } from "@fuse/plugins/zero-config"

import { UserRole } from "@fuse/recoil/pluginStudio/types"

// Re-export types for backward compatibility
export type { ExamplePlugin } from "@fuse/plugins/examples"

// Combine all plugins
export const examplePlugins: ExamplePlugin[] = [
  ...getAllExamplePlugins(),
  ...getAllZeroConfigPlugins(),
]

export const getExamplePluginsByCategory = () => {
  const categories = {}
  examplePlugins.forEach((plugin) => {
    if (!categories[plugin.category]) {
      categories[plugin.category] = []
    }
    categories[plugin.category].push(plugin)
  })
  return categories
}

export const getExamplePluginsByDifficulty = (
  difficulty: "beginner" | "intermediate" | "advanced",
) => {
  return examplePlugins.filter((plugin) => plugin.difficulty === difficulty)
}

export const searchExamplePlugins = (query: string) => {
  const lowercaseQuery = query.toLowerCase()
  return examplePlugins.filter(
    (plugin) =>
      plugin.name.toLowerCase().includes(lowercaseQuery) ||
      plugin.description.toLowerCase().includes(lowercaseQuery) ||
      plugin.tags.some((tag) => tag.toLowerCase().includes(lowercaseQuery)),
  )
}
